import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";
import { EditMaterialForm, GoBackArrow, Loader } from "../../../components";
import PageHeader from "../../../components/carbon/PageHeader/PageHeader";
import { useID } from "../../../hooks";
import { useSites } from "../../../hooks/useSites";
import { useMaterial } from "../../../hooks/useMaterials";
import { useUser } from "../../../context";

const EditMaterial = () => {
  const { user } = useUser();
  const { t } = useTranslation();
  const navigate = useNavigate();
  const id = useID();

  const {
    data: material,
    isError,
    isLoading: isLoadingMaterial,
  } = useMaterial(id);

  const { data: sites, isLoading: isLoadingSite } = useSites(
    user?.company?.id || ""
  );

  if (isError) navigate("/not-found");

  return (
    <div>
      {isLoadingMaterial || isLoadingSite ? (
        <Loader isFullScreen />
      ) : (
        <>
          <GoBackArrow />
          <PageHeader title={t("newMaterialForm.edit")} />
          {material && (
            <EditMaterialForm material={material} sites={sites ?? []} />
          )}
        </>
      )}
    </div>
  );
};

export default EditMaterial;
